import { render, staticRenderFns } from "./fccTipoArquivos.vue?vue&type=template&id=56cfd64c"
import script from "./fccTipoArquivos.vue?vue&type=script&lang=js"
export * from "./fccTipoArquivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports